

export default function MenuItemHint({inputs=[], outputs=[{data_type: "..."}]}) {
    return <div className="project-dfd-menu-item-hint-container">
        <div>{inputs.map((input, i) => <p key={i}>{input.data_type}</p>)}</div>
        <p>-></p>
        <div>{outputs.map((output, i) => <p key={i}>{output.data_type}</p>)}</div>
    </div>;
}
